import images from "../../utils/images"
import styles from "./UltimateBackground.module.scss"

interface Props {
  forceVisible?: boolean
  style?: React.CSSProperties
}

const UltimateBackground = (props: Props) => {
  const style = {
    ...(props.forceVisible ? { visibility: "visible" as const } : {}),
    ...props.style
  }

  return (
    <div className={styles.background} style={style}>
      <img className={`${styles.image} ${images.ultimate.background.class}`} />
    </div>
  )
}

export default UltimateBackground
